import { useEffect, useState } from "react";
import EbasvuruTenantservice from "../../../service/Ebasvuru/EbasvuruTenantService";
import { Box, Button, Card, CardContent, colors, Container, Drawer, Grid, IconButton, useMediaQuery, useTheme } from "@mui/material";
import DynamicFilter from "../../../util/DynamicFilter";
import useGlobal from "../../../util/Global";
import CustLabel from "../../../components/CustLabel";
import ZamanTipiEnum from "../../../enum/Ebasvuru/ZamanTipiEnum";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useQuery from "../../../util/useQuery";
import Accountservice from "../../../service/Core/AccountService";
import { useAppCookies } from "../../../util/useAppCookies";
import StorageUtils from "../../../ui/StorageUtils";
import AdayPage from "./AdayPage";
import { useDispatch, useSelector } from "react-redux";
import { ActionType } from "../../../store/ActionType";
import MenuIcon from "@mui/icons-material/Menu";

const Ilanlar = () => {

    const full = useSelector(user => user.auth);
    const { t } = useGlobal();
    const [projelar, setProjelar] = useState([]);
    const [isler, setIsler] = useState([]);
    const [sehirler, setSehir] = useState([]);
    const [ilceler, setIlceler] = useState([]);
    const [login, setLogin] = useState(null);
    const { setUser } = useAppCookies();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // md = 960px
    const [drawerOpen, setDrawerOpen] = useState(false);

    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };

    const history = useHistory();

    const dispatch = useDispatch();

    const query = useQuery();
    const tenantKey = query.get('tenant');

    const goTo = (props) => {

        if (full?.loginType != "aday" || props.page === 'ilanDetay') {
            StorageUtils.add("aday",
                {
                    basvuruId: props.basvuruId,
                    iapId: props.iapId
                });

            history.push(`/${props.page}`);
        } else {

            full.basvuruId = props.basvuruId;
            full.iapId = props.iapId;

            full.user.basvuruId = props.basvuruId;
            full.user.iapId = props.iapId;

            const adayUser = {
                accessToken: full.token,
                token: full.token,
                loginType: "aday",
                tenantName: full.user.tenantName,
                tenantIcon: full.user.tenantIcon,
                masterToken: full.token,
                userId: full.user.userId,
                basvuruId: props.basvuruId,
                iapId: props.iapId,
                adSoyad: full.user?.adSoyad,
                tenantKey: full.tenantKey
            }

            setUser(adayUser);

            dispatch({
                type: ActionType.ADAY_LOGIN,
                token: full.token,
                loginType: "aday",
                tenantName: full.user.tenantName,
                tenantIcon: full.user.tenantIcon,
                masterToken: full.token,
                userId: full.user.userId,
                basvuruId: full.basvuruId,
                iapId: full.iapId,
                user: full.user,
                tenantKey: full.tenantKey
            });

            Promise.resolve().then(() => {
                history.push("/");
            });

        }
    }


    const filterProjec = (filter) => {
        setDrawerOpen(!drawerOpen);
        EbasvuruTenantservice.Projesi({
            acik: true,
            gorunmeyeAcik: true,
            ...filter

        })
            .then((res) => {
                if (res && res.isSuccess) {

                    setProjelar(res.resultObject);
                }
            });
    }


    const fetchAdayLogin = async () => {
        if (tenantKey) {
            try {
                const res = await Accountservice.loginAsAday({ tenant: tenantKey });

                if (res && res.token) {
                    EbasvuruTenantservice.setToken(res.token);

                    setLogin((prev) => {
                        if (!prev || prev.token !== res.token) {
                            return res;
                        }
                        return prev;
                    });
                    StorageUtils.save("aday",
                        {
                            token: res.token,
                            tenantKey: tenantKey,
                            masterTenant: res.masterTenant
                        }
                    );
                }
            } catch (error) {
                console.error("Login failed:", error);
            }
        }
    };

    useEffect(() => {


        if (!full.user) {
            fetchAdayLogin();
        } else {
            setLogin(full.user);
        }


    }, []); // Runs only once on mount


    useEffect(() => {

        if (login) {
            EbasvuruTenantservice.setToken(login.token);

            EbasvuruTenantservice.Projesi({
                acik: true,
                gorunmeyeAcik: true,

            })
                .then((res) => {
                    if (res && res.isSuccess) {
                        setProjelar(res.resultObject);
                    }
                });

            EbasvuruTenantservice.Sehir().then((res) => {
                if (res && res.isSuccess) {

                    const data = res.resultObject.map((s) => ({ text: s.sehirAdi, value: s.sehirKodu }));
                    setSehir(data);
                }
            });

            EbasvuruTenantservice.Ilceler().then((res) => {
                if (res && res.isSuccess) {
                    const data = res.resultObject.map((s) => ({ text: s.ilceAdi, value: s.ilceKodu, filterKey: s.sehirKodu }));
                    setIlceler(data);
                }
            });

            EbasvuruTenantservice.Isler({ hasIlanl: true }).then((res) => {
                if (res && res.isSuccess) {
                    const data = res.resultObject.map((s) => ({ text: s.isAciklamasi, value: s.id }));
                    setIsler(data);
                }
            });



        }

    }, [login]);


    const filterList = [
        { key: "genelFilter", label: t('col.genelFiltertxt'), tipi: "text" },
        { key: "isId", label: t('col.isAciklamasi'), tipi: "auto", options: isler },
        { key: "ilKodu", label: t('col.sehir'), tipi: "auto", options: sehirler },
        { key: "ilceKodu", label: t('col.IlceAdi'), tipi: "auto", options: ilceler, parent: "ilKodu" },

    ];

    const filterContent = (
        <Grid item xs={12} md={6} lg={3} sx={{ mt: 5 }}>
            <CustLabel labelSx={{ color: "black" }} variant="h6" labelKey='col.TumIsIlanlar' />
            <DynamicFilter filterList={filterList} onFilter={filterProjec} />
        </Grid>

    );

    const mobileContext = (<>
        <IconButton onClick={toggleDrawer(true)} sx={{ mb: 1 }}>
            <MenuIcon sx={{ color: 'white' }} />
        </IconButton>

        <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawer(false)}

        >
            <Container sx={{ mt: 3 }}>{filterContent}</Container>

        </Drawer>
    </>);

    return (
        <AdayPage isLoading={false} menuAction={(isMobile && mobileContext)}>
            <Grid container spacing={2} sx={{ p: 5, pt: 0, minHeight: '81vh' }} >
                {!isMobile && filterContent}

                <Grid item xs={12} md={6} lg={9} sx={{ mt: 4 }}>
                    <Grid container spacing={2}>
                        {projelar.map((job) => (
                            <Grid item sm={12} md={12} lg={6} key={job.id}>
                                <Card elevation={3} sx={{ p: 2 }}>
                                    <CardContent >
                                        <Grid container spacing={2}>
                                            {/* Ilan No */}
                                            <Grid item xs={12}>
                                                <CustLabel
                                                    variant="subtitle2"
                                                    basecolor="#4c4646"
                                                    labelKey='col.ilanNo'
                                                    value={job.iapKodu}
                                                />
                                            </Grid>

                                            {/* Ilan Tarihi and Son Basvuru */}
                                            <Grid item xs={12}>
                                                <Grid container justifyContent="flex-end" spacing={4}>
                                                    <Grid item>
                                                        <CustLabel
                                                            labelKey='col.ilanTarihi'
                                                            value={job.talepTarihi}
                                                            formatType='date'
                                                            layout="column"
                                                            labelSx={{ color: "gray" }}
                                                            valueSx={{ color: 'blue' }}
                                                        />
                                                    </Grid>
                                                    <Grid item>
                                                        <CustLabel
                                                            labelKey='col.sonBasvuru'
                                                            value={job.basvuruBitisTarihi}
                                                            formatType='date'
                                                            layout="column"
                                                            labelSx={{ color: "gray" }}
                                                            valueSx={{ color: 'red' }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            {/* Is Aciklamasi */}
                                            <Grid item xs={12}>
                                                <CustLabel
                                                    label={job.baslik}
                                                    variant="subtitle1"
                                                    basecolor="#55419E"
                                                    labelSx={{ mt: 1 }}
                                                    layout="row"
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <CustLabel
                                                    label={job.kisaAciklama}
                                                    basecolor={"gray"}
                                                    labelSx={{ mt: 0, pt: 0 }}
                                                    layout="row"
                                                />
                                            </Grid>

                                            {/* Zaman Tipi */}
                                            <Grid item xs={12}>
                                                <CustLabel
                                                    labelKey="col.ZamanTipi"
                                                    label="Label"
                                                    value={ZamanTipiEnum[job.zamanTipi]}
                                                    basecolor={"gray"}
                                                    layout="row"
                                                />
                                            </Grid>

                                            {/* Sehir & Ilce */}
                                            {(job.sehirAdi || job.ilceAdi) && (
                                                <Grid item xs={12}>
                                                    <CustLabel
                                                        label={`${job.sehirAdi} - ${job.ilceAdi}`}
                                                        basecolor="gray"
                                                        labelSx={{ mt: 1, fontSize: '12px', fontStyle: 'italic' }}
                                                        layout="row"
                                                    />
                                                </Grid>
                                            )}

                                            {/* Buttons */}
                                            <Grid item xs={12}>
                                                <Grid container spacing={2} justifyContent="space-between">
                                                    <Grid item xs={6}>
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => goTo({ page: "ilanDetay", iapId: job.id, basvuruId: job.basvuruFormuId })}
                                                            sx={{
                                                                backgroundColor: "#D0B3FF",
                                                                color: "#333",
                                                                fontFamily: 'Open Sans, sans-serif',
                                                                fontWeight: 100,
                                                                width: '100%',
                                                            }}
                                                        >
                                                            {t('col.detaylariIncele')}
                                                        </Button>
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => goTo({ page: "adayTelefonOnayi", iapId: job.id, basvuruId: job.basvuruFormuId })}
                                                            sx={{
                                                                backgroundColor: "#5C3B90",
                                                                fontFamily: 'Open Sans, sans-serif',
                                                                fontWeight: 100,
                                                                width: '100%',
                                                            }}
                                                        >
                                                            {t('col.HemenBasvuru')}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>

                                </Card>
                            </Grid>
                        ))
                        }
                    </Grid>
                </Grid>
            </Grid>
        </AdayPage>
    );

}

export default Ilanlar;